import { render, staticRenderFns } from "./Technicians.vue?vue&type=template&id=73ed0dc6"
import script from "./Technicians.vue?vue&type=script&lang=ts"
export * from "./Technicians.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports